module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagel"
  }, [_c('a', {
    attrs: {
      "id": "ch012"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0032-01.jpg",
      "width": "450px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“DOCTOR KATHERINE PULASKI (played by Diana Muldaur): Doctor Pulaski came to the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" as Chief Medical Officer as a result of Doctor Beverly Crusher’s strong recommendation. We gather that on leaving the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" to become head of Starfleet Medical, Beverly had made use of her new position and her knowledge of the "), _c('em', [_vm._v("Enterprise")]), _vm._v(" to force Doctor Pulaski’s appointment….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She has abrasive edges to her personality and is not at all uncertain of herself and her opinions. She is also the intellectual equal of Captain Picard. Fortunately, she also understands the realities of command and Picard’s years of deep space experience and carefully defers to him in those areas….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pulaski is a few years younger than her Captain…. A 24th Century woman in almost every way, she is amused by pretension. Marriage being just one of many options in this era, she has three grown children by three different men….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pulaski is a humanity lover, passionately fond of the human species…. She is the only crewmember who treats Data like a machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide ’88–89, second-season revision")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“GUINAN (played by Whoopi Goldberg): Guinan is an alien female from a very distant planet. Picard, when a young officer on the "), _c('em', [_vm._v("U.S.S. Stargazer")]), _vm._v(", was fascinated by members of her life-form that he met. Now Captain of one of the vast "), _c('em', [_vm._v("Galaxy")]), _vm._v("-class star-ships with its immense crew and facilities, he has discovered that this very kind of person would be a perfect choice to operate the "), _c('em', [_vm._v("Ten-Forward")]), _vm._v(" facility….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We do not know Guinan’s age. She is a "), _c('em', [_vm._v("human-oid")]), _vm._v(" with many similarities to the human form, but also with some subtle differences…. She combines the loveliness of wisdom and child. We’ll learn from Picard that she is at least ‘several centuries’ old….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She is a born catalyst, able to fit into a ‘customer’s’ mood…. As Picard discovered long ago, Guinan is a member of a "), _c('em', [_vm._v("Listener")]), _vm._v(" life-form. Something about her life-form "), _c('em', [_vm._v("encourages others to be honest when they speak")]), _vm._v("—and perhaps old-style bartenders had something of the same ability.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("—from the "), _c('em', [_vm._v("Star Trek: The Next Generation")]), _vm._v(" writers’/directors’ guide, special edition 1992–93")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0033-01.jpg",
      "width": "450px"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11356959","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch012.vue
// module id = 108
// module chunks = 0